<p-divider align="center" type="dashed">
	<b>Sales & Ops Snapshot</b>
</p-divider>
<div class="ms-2">
	<div class="p-grid">
		<div class="p-col">
			<div class="p-grid">
				<div class="p-col">Net Sales</div>
				<div class="p-col">
					{{ +salesSummary.NetSales | currency }}
				</div>
				<div class="p-col">Net Cash</div>
				<div class="p-col">
					{{ +salesSummary.NetCash | currency }}
				</div>
			</div>
		</div>
		<div class="p-col">
			<div class="p-grid">
				<div class="p-col">Voids</div>
				<div class="p-col">{{ +salesSummary.VoidAmount | currency }} ({{ +salesSummary.VoidCount }})</div>
				<div class="p-col">Discounts</div>
				<div class="p-col">{{ +salesSummary.DiscountAmount | currency }} ({{ +salesSummary.DiscountCount }})</div>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col">
			<div class="p-grid">
				<div class="p-col">Labor Cost</div>
				<div class="p-col">{{ +salesSummary.LaborCost | currency }} ({{ salesSummary.LaborPercentage }}%)</div>
				<div class="p-col">Average Check</div>
				<div class="p-col">{{ +salesSummary.AverageCheck | currency }} ({{ salesSummary.CheckCount }})</div>
			</div>
		</div>
		<div class="p-col">
			<div class="p-grid">
				<div class="p-col">Average Guest</div>
				<div class="p-col">{{ +salesSummary.AverageGuest | currency }} ({{ +salesSummary.GuestCount }})</div>
				<div class="p-col">Open Checks</div>
				<div class="p-col">
					{{ +salesSummary.OpenCheckCount }}
				</div>
			</div>
		</div>
	</div>
	<div class="small p-text-right">
		<i>as of {{ moment(createdDate).format("l LT") }}</i>
	</div>
</div>
